export default __webpack_public_path__ + "static/media/profile-infra.1e63c0ef.webp";